import { Injectable } from '@angular/core';
import { PlanningItem } from '@mocca-technologies/model';

@Injectable({ providedIn: 'root' })
export class SharedRelayService {

    // Planning selection
    items = new Set<PlanningItem>();

    // Schedule Selected
    schOperation = null;

    constructor() { }
}
